module.exports = __webpack_public_path__ + "static/img/7.31add37.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/eng/7.png
// module id = yASI
// module chunks = 0